module.exports = __webpack_public_path__ + "assets/img/under.26ec6a36.svg";